import _toConsumableArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useEffect, useState } from 'react';
export var useDerivedState = function useDerivedState(setter, dependencies) {
  var _useState = useState(setter()),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  useEffect(function () {
    setValue(setter());
  }, [setValue].concat(_toConsumableArray(dependencies)));
  return [value, setValue];
};